

/**
 * 
 * @param {string} html 
 */
export const transformHTMLToText = (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
} 